import { theme } from 'modules/ui/theme';
import { BodyText, Label } from 'modules/ui/typography';
import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;

  :hover > * {
    color: ${theme.colors.primaryK2};
    cursor: pointer;
  }
`;

export const StyledItemCategory = styled(BodyText)`
  min-width: 3.75rem;
  margin-right: 1.375rem;
  margin-bottom: 0rem;
  color: ${theme.colors.primaryW};
`;

export const StyledItemNumber = styled(Label)`
  font-size: var(--h4-font-size);
  line-height: var(--h3-line-height);

  min-width: 5.6rem;
  margin-bottom: 0rem;
  color: ${theme.colors.primaryW};
`;
